import { memo } from 'react'
import { AddExistingUserTable } from './components/addExistingUserTable/addExistingUserTable'
import { useProjectMemberEntryContext } from 'features/project/components/projectMemberEntryDialog/useProjectMemberEntryDialog'

export const AddExistingUserListPanel = memo(() => {
  const { selectedExistingUsers } = useProjectMemberEntryContext()

  return <AddExistingUserTable selectedExistingUsers={selectedExistingUsers} />
})
